var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* tslint:disable */
/* eslint:disable */
/**
* @typedef {string} Url
*/
/**
* @typedef {string} GUID
*/
/**
* @typedef {number} DateTime
*/
var dummy;
var defaultConfig = { endpoint: 'ccpa-consent' };
var init = function (webOrMobileLogger) { return function (userConfig) {
    if (userConfig === void 0) { userConfig = {}; }
    var defaults = userConfig.defaults, restOfConfig = __rest(userConfig, ["defaults"]);
    var config = __assign(__assign({}, defaultConfig), restOfConfig);
    var factoryInstance = typeof webOrMobileLogger.factory === 'function' ? webOrMobileLogger.factory(config) : webOrMobileLogger;
    var logger = getLogger(factoryInstance);
    return defaults ? logger.util.updateDefaults(defaults) : logger;
}; };
export var initCustomLogger = function (factoryInstance) { return getLogger(factoryInstance); };
var getLogger = function (biLoggerClientFactoryInstance) {
    return new Logger(biLoggerClientFactoryInstance);
};
var Logger = /** @class */ (function () {
    function Logger(biLoggerClientFactoryInstance) {
        var _this = this;
        this.biLoggerClientFactoryInstance = biLoggerClientFactoryInstance;
        /*event 7500 on project 'com.wixpress.ccpa-consent has no function name set, please set one in BI Catalog.*/
        this.util = {
            updateDefaults: function (defaults) {
                _this.biLoggerClientFactoryInstance.updateDefaults(defaults);
                return _this;
            },
            log: function (logParams, context) {
                return _this.bi.log(logParams, context);
            }
        };
        biLoggerClientFactoryInstance
            .updateDefaults({ src: 5 });
        this.bi = biLoggerClientFactoryInstance.logger({ endpoint: 'ccpa-consent' });
    }
    ;
    /**
    * @typedef {Object} cookiesBannerUouUouClickOnDoNotSellMyDataLinkParams
    
    **/
    /**
     * Name: Cookies banner UoU- UoU click on ‘Do Not Sell my Data’ link. Evid: 1085.
     * Event description: UoU clicked the 'Do Not Sell my Data’ link in a user site.
    
    
     * @param {cookiesBannerUouUouClickOnDoNotSellMyDataLinkParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.cookiesBannerUouUouClickOnDoNotSellMyDataLink = function (params) {
        return this.bi.log(__assign({ evid: 1085 }, params));
    };
    /**
    * @typedef {Object} cookiesBannerUouUouDisableDataTransfersPopUpIsDisplayParams
    
    **/
    /**
     * Name: Cookies banner UoU- UoU 'disable data transfers?' pop-up is display. Evid: 1086.
     * Event description: UoU 'disable data transfers?  popup is displayed.
    
    
     * @param {cookiesBannerUouUouDisableDataTransfersPopUpIsDisplayParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.cookiesBannerUouUouDisableDataTransfersPopUpIsDisplay = function (params) {
        return this.bi.log(__assign({ evid: 1086 }, params));
    };
    /**
    * @typedef {Object} cookiesBannerUouUouWithDisableDataTransfersPopUpParams
    * @property {string} action - close / disable transfers
    **/
    /**
     * Name: Cookies banner UoU- UoU with  'disable data transfers?' pop-up. Evid: 1087.
     * Event description: UoU interaction with the 'disable data transfers?' pop-up.
    
     * action - Type: string. Desc: close / disable transfers
     * @param {cookiesBannerUouUouWithDisableDataTransfersPopUpParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.cookiesBannerUouUouWithDisableDataTransfersPopUp = function (params) {
        return this.bi.log(__assign({ evid: 1087 }, params));
    };
    return Logger;
}());
export { Logger };
export default init;
export function getLoggerConf() {
    return {
        src: 5,
        endpoint: 'ccpa-consent'
    };
}
//# sourceMappingURL=index.js.map